<template>
  <div class="contact-category-list">
    <div class="search-bar-component">
      <b-row class="mb-1 mb-md-2">
        <b-col cols="12">
          <b-input-group size="lg" class="input-group-merge">
            <b-input-group-prepend is-text>
              <feather-icon icon="SearchIcon" />
            </b-input-group-prepend>
            <b-form-input v-model="searchQuery" placeholder="Sök kontakt..." />
          </b-input-group>
        </b-col>
      </b-row>
    </div>
    <b-row v-for="accessGroup in accessGroups" :key="accessGroup.id">
      <b-col cols="12">
        <div
          v-if="
            filteredContacts.find((ct) =>
              ct.access_groups.find((ctac) => ctac.id === accessGroup.id)
            )
          "
          :class="'contact-group contact-group-' + accessGroup.id"
        >
          <b-button
            v-b-toggle="'collapse-' + accessGroup.id"
            variant="flat"
            class="border-bottom mb-1"
            block
            ><h4 class="mb-0">
              {{ accessGroup.title }}
              <span class="text-primary"
                ><i class="fas fa-caret-down"></i
              ></span></h4
          ></b-button>
          <b-collapse visible :id="'collapse-' + accessGroup.id">
            <div class="ce-contact-list">
              <div
                v-for="(contact, index) in filteredContacts"
                :key="contact.id"
              >
                <template
                  v-if="
                    contact.access_groups.find((a) => a.id == accessGroup.id)
                  "
                >
                  <b-card
                    class="ce-contact-list-item"
                    :class="{
                      selected: selectedContacts.find(
                        (ct) => ct === contact.id
                      ),
                    }"
                    @click="emitSelectedContacts(contact)"
                    no-body
                  >
                    <div class="card-body">
                      <b-row>
                        <b-col cols="12" class="ce-contact-info">
                          <div class="ce-contact-avatar">
                            <b-avatar
                              v-if="contact.user_id"
                              size="4rem"
                              :src="contact.avatar ? contactAvatars[index] : ''"
                              badge
                              badge-variant="success"
                              badge-offset="-2px"
                            />
                            <b-avatar
                              v-else
                              size="4rem"
                              :src="contact.avatar ? contactAvatars[index] : ''"
                            />
                          </div>
                          <div class="ce-contact-description">
                            <h6 class="mb-0">
                              {{ contact.first_name }} {{ contact.last_name }}
                            </h6>
                            <p>
                              <small
                                ><span v-if="contact.organisation">{{
                                  contact.organisation
                                }}</span></small
                              >
                            </p>
                          </div>

                          <div class="icon icon-add">
                            <span class="text-primary"
                              ><i class="fas fa-square"></i
                            ></span>
                          </div>
                          <div class="icon icon-checked">
                            <span class="text-success"
                              ><i class="fas fa-check-square"></i
                            ></span>
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </b-card>
                </template>
                <template v-else></template>
              </div>
            </div>
          </b-collapse>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BInputGroup,
  BFormInput,
  BInputGroupPrepend,
  BCard,
  BButton,
  BCollapse,
  BAvatar,
} from "bootstrap-vue";
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "SelectContacts",
  components: {
    BRow,
    BCol,
    BInputGroup,
    BFormInput,
    BInputGroupPrepend,
    BCard,
    BButton,
    BCollapse,
    BAvatar,
  },
  props: {
    currentContacts: Array,
  },
  data() {
    return {
      searchQuery: "",
      selectedContacts: [],
      oldContacts: [],
      contactAvatars: [],
    };
  },
  async mounted() {
    this.selectedContacts = [...this.currentContacts] ?? [];
    this.oldContacts = [...this.currentContacts] ?? [];

    for (let i = 0; i < this.filteredContacts.length; i++) {
      if (this.filteredContacts[i].avatar) {
        this.$set(
          this.contactAvatars,
          i,
          await this.fetchImageWithToken(
            this.filteredContacts[i].avatar.original
          )
        );
      } else {
        this.$set(this.contactAvatars, i, null);
      }
    }
  },

  computed: {
    ...mapGetters({ contacts: "getContacts" }),
    accessGroups() {
      return this.getFilteredAccessGroups();
    },
    filteredContacts() {
      return this.contacts.filter((contact) => {
        if (!contact.first_name) return;

        return (
          contact.first_name
            .toLowerCase()
            .includes(this.searchQuery.toLowerCase()) ||
          contact.last_name
            .toLowerCase()
            .includes(this.searchQuery.toLowerCase()) ||
          contact.organisation
            .toLowerCase()
            .includes(this.searchQuery.toLowerCase())
        );
      });
    },
  },
  methods: {
    async fetchImageWithToken(imageUrl) {
      try {
        const token = JSON.parse(localStorage.getItem("user")).jwt;

        const response = await axios.get(imageUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        });

        // use the set $ to upade the imageUrls
        return URL.createObjectURL(response.data);
      } catch (error) {
        return "";
      }
    },
    getFilteredAccessGroups() {
      if (!this.contacts) return;

      let filtered = [];
      for (let i = 0; i < this.contacts.length; i++) {
        for (let j = 0; j < this.contacts[i].access_groups.length; j++) {
          if (
            filtered.find((a) => a.id == this.contacts[i].access_groups[j].id)
          )
            continue;
          filtered.push(this.contacts[i].access_groups[j]);
        }
      }

      filtered.sort((a, b) => a.sort_order - b.sort_order);
      return filtered;
    },
    emitSelectedContacts: function (contact) {
      this.selectedContacts.find((ctId) => ctId === contact.id)
        ? this.selectedContacts.splice(
            this.selectedContacts.findIndex((ctId) => ctId === contact.id),
            1
          )
        : this.selectedContacts.push(contact.id);
      this.$emit("selectedContactsUpdated", {
        newContacts: this.selectedContacts,
        oldContacts: this.oldContacts,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/variables/_variables.scss";
.contact-group > .btn {
  text-align: left;
  padding-left: 0;
  /* border: 0!important;
        background-color: #fff;
        box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%); */
}
.contact-group > .btn span {
  float: right;
}
.btn svg {
  transition: all 0.25s ease-in-out;
}
.btn.collapsed svg {
  transform: rotate(180deg);
}
.btn.not-collapsed svg {
  transform: rotate(0deg);
}
.card {
  margin-bottom: 1rem;
}
.ce-contact-list-item:hover {
  cursor: pointer;
}
.ce-contact-info {
  display: flex;
  align-items: center;
}
.ce-contact-avatar {
  padding-right: 1rem;
}
.ce-contact-description {
  padding-right: 0.5rem;
  margin-right: auto;
}
.ce-contact-info .icon {
  font-size: 1.5rem;
  padding-right: 0.75rem;
}
.icon-checked {
  display: none;
}
.selected .icon-add {
  display: none;
}
.selected .icon-checked {
  display: block;
}
</style>
